import { render, staticRenderFns } from "./NomeEditavel.vue?vue&type=template&id=840eecda"
import script from "./NomeEditavel.vue?vue&type=script&lang=js"
export * from "./NomeEditavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports